import React, { useState, useEffect } from 'react';
import api from '../api';

function Settings() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [currentPassword, setCurrent] = useState('');
  const [newPassword, setNew] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.get('/api/user/profile').then(res => {
      setName(res.data.name);
      setEmail(res.data.email);
    });
  }, []);

  const updateProfile = async () => {
    await api.put('/api/user/profile', { name, email });
    setMessage('Profile updated');
  };

  const changePassword = async () => {
    await api.put('/api/user/change-password', { currentPassword, newPassword });
    setMessage('Password changed');
  };

  return (
    <div>
      <h2>Settings</h2>
      {message && <p style={{ color: 'green' }}>{message}</p>}
      <div className="card" style={{ maxWidth: '500px', marginBottom: '1.5rem' }}>
        <h3>Profile</h3>
        <input
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="Name"
          style={{ width: '100%', padding: '0.75rem', marginBottom: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
        />
        <input
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Email"
          style={{ width: '100%', padding: '0.75rem', marginBottom: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
        />
        <button onClick={updateProfile} className="copy-btn" style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '0.5rem 1.5rem', borderRadius: '0.5rem', fontWeight: 500 }}>
          Update Profile
        </button>
      </div>

      <div className="card" style={{ maxWidth: '500px' }}>
        <h3>Change Password</h3>
        <input
          type="password"
          placeholder="Current password"
          value={currentPassword}
          onChange={e => setCurrent(e.target.value)}
          style={{ width: '100%', padding: '0.75rem', marginBottom: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
        />
        <input
          type="password"
          placeholder="New password (min 8 chars)"
          value={newPassword}
          onChange={e => setNew(e.target.value)}
          style={{ width: '100%', padding: '0.75rem', marginBottom: '0.75rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0' }}
        />
        <button onClick={changePassword} className="copy-btn" style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '0.5rem 1.5rem', borderRadius: '0.5rem', fontWeight: 500 }}>
          Change Password
        </button>
      </div>
    </div>
  );
}
export default Settings;